import Tab from './Tab';
import Tabs from './Tabs';

export {
    Tab, 
    Tabs
}


// WEBPACK FOOTER //
// ./src/components/tabs/index.js